/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import Typography from '@mui/material/Typography';
import withBoundary from 'component/ErrorBoundary/withBoundary';

const AutoUpdate = () => {
  const [hasUpdate, setHasUpdate] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [tracker, setTracker] = useState({});
  const [timeout, setTimeout] = useState(30);
  const timeoutIntervalRef = useRef(null);
  const updateIntervalRef = useRef(null);
  // const dispatch = useDispatch();
  const onUpdate = (key, value) => {
    if (timeoutIntervalRef.current) clearInterval(timeoutIntervalRef.current);
    timeoutIntervalRef.current = null;
    window.localStorage.setItem(key, value);
    window.location.reload(true);
  };
  useEffect(() => {
    if (timeout <= 0) {
      onUpdate(tracker.key, tracker.value);
    }
  }, [timeout]);
  const checkForUpdate = () => {
    fetch('/asset-manifest.json')
      .then((response) => response.json())
      .then((data) => {
        const key = process.env.REACT_APP_VERSION_KEY;
        const main = window.localStorage.getItem(key);
        const value = data.files['main.js'];
        if (!main) {
          window.localStorage.setItem(key, value);
          return;
        }

        if (main !== data.files['main.js']) {
          setTracker({
            key,
            value
          });
          setHasUpdate(true);
          if (updateIntervalRef.current)
            clearInterval(updateIntervalRef.current);
          if (timeoutIntervalRef.current)
            clearInterval(timeoutIntervalRef.current);
          timeoutIntervalRef.current = setInterval(() => {
            setTimeout((timeout) => timeout - 1);
          }, 1000);
        }
      })
      .catch(console.log);
  };
  useEffect(() => {
    if (updateIntervalRef.current) clearInterval(updateIntervalRef.current);
    updateIntervalRef.current = setInterval(checkForUpdate, 60000);

    return () => {
      clearInterval(updateIntervalRef.current);
    };
  }, []);

  return hasUpdate ? (
    <Typography className="auto-update" variant="labelTiny">
      App Update Available, Auto-updating the app in {timeout} sec, or click
      reload button to update now.
      <button
        className="button-control"
        style={{ textDecoration: 'underline' }}
        onClick={() => onUpdate(tracker.key, tracker.value)}>
        Reload
      </button>
    </Typography>
  ) : null;
};
export default React.memo(withBoundary(AutoUpdate));
